<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.empCmsEntrance.entranceCode']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="entranceCode">
              <a-input v-model="model.entranceCode" :placeholder="this.language['common.pleaseInput']+this.language['emp.empCmsEntrance.entranceCode']"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.empCmsEntrance.entranceName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="entranceName">
              <a-input v-model="model.entranceName" :placeholder="this.language['common.pleaseInput']+this.language['emp.empCmsEntrance.entranceName']"  style="width: 85%"></a-input>
              <a-button @click="languageModelOpen('EmpCmsEntrance','entranceName',entranceNameLanguages)" type="primary"  style="left: 3%" :disabled="false">{{language['common.language']}}</a-button>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.empCmsEntrance.description']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="description">
              <a-input v-model="model.description" :placeholder="this.language['common.pleaseInput']+this.language['emp.empCmsEntrance.description']"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.empCmsEntrance.setManager']" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-radio-group v-model="isSetManager" @change="setManagerChange">
                <a-radio value="Y">{{language['common.yes']}}</a-radio>
                <a-radio value="N">{{language['common.no']}}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="24" v-show="isSetManager=='Y'">
            <div style="padding-left: 16%;padding-right: 13%;">
              <div style="border: 1px solid #262626;border-radius: 5px;padding: 10px;">
                <emp-entrance-manager-user-form ref="entranceManagerUserForm" @ok="close"></emp-entrance-manager-user-form>
              </div>
            </div>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.empCmsEntrance.status']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="status">
              <j-dict-select-tag type="radio" v-model="model.status" :trigger-change="true" dictCode="emp_entrance_status" />
            </a-form-model-item>
          </a-col>
          <!--<a-col :span="24">
            <a-form-model-item label="发布人/撤销人" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="publisher">
              <a-input v-model="model.publisher" placeholder="请输入发布人/撤销人"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="发布时间/撤销时间" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="publishTime">
              <j-date placeholder="请选择发布时间/撤销时间" v-model="model.publishTime"  style="width: 100%" />
            </a-form-model-item>
          </a-col>-->
          <a-col :span="24">
            <a-form-model-item :label="language['emp.empCmsEntrance.sortNo']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="sortNo">
              <a-input-number v-model="model.sortNo" :placeholder="this.language['common.pleaseInput']+this.language['emp.empCmsEntrance.sortNo']" style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <!--<a-col :span="24">
            <a-form-model-item label="刪除标示" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="delFlag">
              <a-input v-model="model.delFlag" placeholder="请输入刪除标示"  ></a-input>
            </a-form-model-item>
          </a-col>-->
          <a-col :span="24">
            <a-form-model-item :label="language['emp.empCmsEntrance.remark']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="remark">
              <a-input v-model="model.remark" :placeholder="this.language['common.pleaseInput']+this.language['emp.empCmsEntrance.remark']"  ></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
    <language-model ref="languageModel" @ok="languageOk"></language-model>
  </a-spin>
</template>

<script>

  import { httpAction, getAction,postAction } from '@/api/manage'
  import LanguageModel from "@/components/LanguageModel"
  import EmpEntranceManagerUserForm from './EmpEntranceManagerUserForm'
  import { duplicateCheck } from '@/api/api'
  export default {
    name: 'EmpCmsEntranceForm',
    components: {
      LanguageModel,
      EmpEntranceManagerUserForm
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{},
        isSetManager:'',
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
           entranceCode: [
              { required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['emp.empCmsEntrance.entranceCode']},
             {validator: this.validateEntranceCode}
           ],
           entranceName: [
              { required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['emp.empCmsEntrance.entranceName']},
             {validator: this.validateEntranceName}
           ],
          sortNo: [
              { required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['emp.empCmsEntrance.sortNo']},
           ],
          status: [
            { required: true, message: this.$store.getters.language['common.pleaseChoose']+this.$store.getters.language['emp.empCmsEntrance.status']},
          ],
           /*delFlag: [
              { required: true, message: '请输入刪除标示!'},
           ],*/
        },
        url: {
          add: "/hhemp/entrance/empcmsentrance",
          edit: "/hhemp/entrance/empcmsentrance",
          queryById: "/hhemp/entrance/empcmsentrance/"
        },
        entranceNameLanguages:[],
        entranceManagers:[],
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      language() {
        return this.$store.getters.language
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      validateEntranceCode(rule, value, callback) {

        // 重复校验
        let params = {
          tableName: 'emp_cms_entrance',
          fieldName: 'entrance_code',
          fieldVal: value,
          dataId: this.model.id,
          delFlag:1
        };
        duplicateCheck(params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback(res.message)
          }
        })
      },
      validateEntranceName(rule, value, callback) {

        // 重复校验
        let params = {
          tableName: 'emp_cms_entrance',
          fieldName: 'entrance_name',
          fieldVal: value,
          dataId: this.model.id,
          delFlag:1
        };
        duplicateCheck(params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback(res.message)
          }
        })
      },
      setManagerChange(){
        if(this.isSetManager=='Y'){
          let list = [];
          if(this.entranceManagers.length>0){
            this.entranceManagers.forEach(item=>{
              let map = {};
              map.id = item.managerId;
              map.workNo = item.managerWorkNo
              map.realname = item.managerName
              list.push(map);
            })
          }
          this.$refs.entranceManagerUserForm.edit(list);
        }
      },
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.isSetManager='Y';
        this.initManagers(record.id);
        this.initLanguagetemp("EmpCmsEntrance","entranceName",record.id);
        this.visible = true;
      },
      initManagers(entranceId){
        if(!!entranceId){
          getAction("/hhemp/entranceManager/list",{entranceId:entranceId}).then(res=>{
            if(res.success){
              this.entranceManagers = res.result;
              if(this.entranceManagers.length>0){
                this.isSetManager='Y';
                this.setManagerChange()
              }else{
                this.isSetManager='N';
              }

            }
          })
        }else{
          this.$refs.entranceManagerUserForm.edit([]);
        }
      },
      languageModelOpen(dataTable, dataColumn, languagelist) {
        this.$refs.languageModel.edit("platform", dataTable, dataColumn, this.model.id, languagelist, this.disabled);
      },
      languageOk(map) {
        if (map && map.dataColumn == 'entranceName') {
          this.entranceNameLanguages = map.languagelist;
        }
      },
      initLanguagetemp(dataTable, dataColumn, dataId) {
        getAction("/sys/syslanguagedata/querylistby", {
          applicationCode: "platform",
          dataTable: dataTable,
          dataColumn: dataColumn,
          dataId: dataId
        }).then((res) => {
          if (res.success) {
            if (dataColumn == 'entranceName') {
              this.entranceNameLanguages = res.result;
            }
          }
        })
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                let modelData = res.result;
                if(this.isSetManager=='Y'){
                  this.$refs.entranceManagerUserForm.handleOk(modelData.id,modelData);
                }else{
                  this.deleteManaers(modelData.id);
                  this.close(modelData)
                }
              }else{
                that.$message.success(this.language["common.errorContext"]);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
      deleteManaers (entranceId) {
        if(!!entranceId){
          postAction("/hhemp/entranceManager/deleteBatchEntranceId/"+entranceId).then(res=>{
            if(res.success){
            }else{
              this.$message.success(this.language["common.errorContext"]);
            }
          })
        }
      },
      close(modelData){
        let list = []
        this.entranceNameLanguages.forEach(item => {
          if (!item.dataId) {
            item.dataId = modelData.id;
          }
          list.push(item);
        })
        httpAction("/sys/syslanguagedata/saveSysLanguageDataList", list, "post").then((res) => {
          if (res.success) {
            this.$message.success(this.language["operationSuccess"]);
            this.$emit('ok');
            this.confirmLoading = false;
          }
        })
      },
    }
  }
</script>
